import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useState } from 'react'
import { Header } from '@/components/navigation/header'
import { Sidebar } from '@/components/navigation/sidebar'
import { ModalProvider, UserModal, TransactionModal, OrderModal } from '@/components/modals'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/auth/login',
        search: {
          redirect: location.pathname,
          activated: undefined,
        },
      })
    }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <ModalProvider>
      <div className="min-h-screen bg-white dark:bg-[#131313]">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        
        <div className="flex">
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          
          {/* pb-24 keeps end-of-page actions clear of the floating chat trigger
            (fixed bottom-6 right-6, ~72px tall zone) — without it the FAB can
            permanently cover a page's final submit button. */}
        <main className="flex-1 min-w-0 min-h-[calc(100vh-4rem)] pb-16 transition-all duration-300 container:ml-0">
            <Outlet />
          </main>
        </div>
        
        {/* Global Modals */}
        <UserModal />
        <TransactionModal />
        <OrderModal />
      </div>
    </ModalProvider>
  )
}
